// extracted by mini-css-extract-plugin
export default {"waveContainer":"styles_waveContainer__f8ujr","wave":"styles_wave__J292g"};